import { NoInput } from '@models/modal';
import {
  createModalDataToken,
  createModalOpener
} from 'src/app/helpers/create-modal-opener';
import { WorkItemsQaGenericReportComponent } from './work-items-qa-generic-report.component';

export const WORK_ITEMS_QA_GENERIC_REPORT_DATA = createModalDataToken<NoInput>(
  'WorkItemsQaGenericReportData'
);

export const workItemsQaGenericReportOpener = createModalOpener(
  WorkItemsQaGenericReportComponent,
  WORK_ITEMS_QA_GENERIC_REPORT_DATA,
  { windowClass: 'modal-large', backdrop: 'static' }
);
